
const state = {
    isConnected: false,
    subscribedChannels: [],
}

const getters = {
    connectionStatus: (state) => {
        return state.isConnected
    },

    subscribedChannels: (state) => {
        return state.subscribedChannels
    },
}

const actions = {
    connected({ commit }, status) {
        try {
            commit('update', status)
        } catch (error) {
        }
    },
}

const mutations = {
    update(state, connected) {
        state.isConnected = connected
    },

    subscribe(state, data) {
        state.subscribedChannels.push(data)
    },

    unsubscribe(state, channel) {
        state.subscribedChannels = state.subscribedChannels.filter((item) => {
            return item.channel !== channel
        })
    },

    flushChannels(state) {
        state.subscribedChannels = []
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
